<template>
  <v-dialog v-model="dialog" max-width="480px">
    <v-card>
      <v-card-title class="mx-3">
        {{ title ? title : $t("Import.import", [objName]) }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 py-8 text-center subtitle-1">
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="text-left my-2">
              {{ template }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <v-btn
                      v-if="!tmpUrl"
                      color="primary"
                      :disabled="isDisabled"
                      class="ms-1"
                      @click="createTmp()"
              >
                {{ $t("Import.downloadFieldTemplateBtn") }}
              </v-btn>
              <v-btn
                      v-else
                      color="primary"
                      class="ms-1"
                      :href="tmpUrl"
              >
                {{ $t("Import.downloadFieldTemplateBtn") }}
              </v-btn>
            </v-list-item-subtitle>

            <v-list-item-title class="text-left my-2">
              {{ upload ? upload : $t("Import.uploadField", [objName]) }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <v-file-input
                v-model="excelFile"
                show-size
                :label="$t('Import.fileInputLabel')"
                accept=".xls,.xlsx"
              ></v-file-input>
            </v-list-item-subtitle>
            <span v-if="isTips">
              <v-list-item-title class="text-left my-2">
                {{ $t("$vuetify.alert") }}
              </v-list-item-title>
              <v-list-item-subtitle
                class="text-left my-1"
                v-for="detail in tipDetails"
                :key="detail"
              >
                {{ detail }}
              </v-list-item-subtitle>
            </span>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn color="primary" depressed @click="$emit('import', excelFile)">
          {{ $t("Import.confirmImport") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import StockIns from "@/api/stock_in_orders";
export default {
  name: "ImportExcelDialog",

  props: {
    value: Boolean,
    title: String,
    objName: String,
    isTips: Boolean,
    tipDetails: Array,
    downloadFromAPI: Boolean,
    downloadTemplateUrl: String,
    template: String,
    upload: String,
    temData: Object
  },

  data: () => ({
    dialog: false,
    excelFile: null,
    tmpUrl: null,
    isDisabled: false
  }),

  methods: {
    createTmp() {
      this.$store.dispatch("fullscreenLoading");
      this.isDisabled = true;
      StockIns.getImportTemplate(this.temData).then(
              function (response) {
                if (response.data.status.isOK()) {
                  window.open(response.data.excel_url, '_self')
                  this.tmpUrl = response.data.excel_url
                }
                this.isDisabled = false;
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
      )
              .catch(
                      function () {
                        this.isDisabled = false;
                        this.$store.dispatch("fullscreenLoadingStop");
                      }.bind(this)
              );
    }
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.excelFile = null;
        }
        this.$emit("input", this.dialog);
      },
    },
  },
};
</script>